import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var HancomOfficeHangulColorIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 21h7.364c.903 0 1.636-.733 1.636-1.637v-2.864h-9v4.5Z",
        fill: "#98D0F5"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M12 16.502h9v-4.5h-9v4.5Z", fill: "url(#paint0_linear_869_1254)" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 12.001h9V7.5h-9v4.501Z",
        fill: "url(#paint1_linear_869_1254)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 7.5h9V4.636C21 3.733 20.267 3 19.364 3H12v4.5Z",
        fill: "url(#paint2_linear_869_1254)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 21V3h3.273c-.235 1.374-.79 4.776-1.19 8.533-.425 3.989-.619 8.092-.675 9.467H12Z",
        fill: "url(#paint3_linear_869_1254)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.29 3H12v18H5.29c-.608 0-.913 0-1.16-.08a1.636 1.636 0 0 1-1.05-1.05C3 19.622 3 19.317 3 18.71V5.29c0-.608 0-.913.08-1.16a1.636 1.636 0 0 1 1.05-1.05C4.378 3 4.683 3 5.29 3Z",
        fill: "url(#paint4_linear_869_1254)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.234 6.662H7.97c.01-.113.018-.306.018-.541v-.533h-.973v.533c0 .234.012.428.018.54H4.767v.917h1.127c-.366.27-.562.72-.562 1.285 0 1.086.862 1.975 2.168 1.975S9.67 9.952 9.67 8.863c0-.568-.226-1.032-.563-1.285h1.128v-.916ZM7.5 9.925c-.705 0-1.196-.55-1.196-1.199 0-.648.491-1.199 1.196-1.199s1.196.55 1.196 1.2c0 .648-.49 1.198-1.196 1.198Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_869_1254",
          x1: 16.5,
          y1: 16.502,
          x2: 16.5,
          y2: 12.002,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#37A5FA" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.115, stopColor: "#42ADFF" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint1_linear_869_1254",
          x1: 16.5,
          y1: 12.001,
          x2: 16.5,
          y2: 7.5,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#007BD9" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.125, stopColor: "#0082E5" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint2_linear_869_1254",
          x1: 16.5,
          y1: 7.501,
          x2: 16.5,
          y2: 3,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#00458A" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.115, stopColor: "#004D99" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint3_linear_869_1254",
          x1: 12.201,
          y1: 7.696,
          x2: 14.164,
          y2: 7.892,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopOpacity: 0.49 }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopOpacity: 0 })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint4_linear_869_1254",
          x1: 7.5,
          y1: 3,
          x2: 7.5,
          y2: 21,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#42ADFF" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#33A7FF" })
          ]
        }
      )
    ] })
  ] })
);

export { HancomOfficeHangulColorIcon };
